module.exports = __webpack_public_path__ + "media/scholarships/icon-apple-ed2a0734.svg";